import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgRulesVegetarian({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M7.577 3.822c2.49 0 4.578 1.612 4.578 3.717 0 2.922-2.21 8.461-4.578 8.461C5.21 16 3 10.46 3 7.539c0-2.105 2.088-3.717 4.577-3.717zm0 1.595c-1.215 0-2.228.521-2.699 1.232h1.468a.798.798 0 010 1.596H4.65c.107.78.364 1.736.696 2.66H6.99a.798.798 0 110 1.595l-.977.001c.533 1.097 1.117 1.903 1.564 1.903.71 0 1.767-2.034 2.414-4.032H8.585a.798.798 0 110-1.595h1.596c.079 0 .155.011.227.033a6.66 6.66 0 00.151-1.271c0-1.12-1.296-2.122-2.982-2.122zM10.79-.004l.068.007a.5.5 0 01.406.58l-.051.26c-.238 1.098-.695 1.856-1.372 2.271-.839.516-1.597.64-2.275.373a1.429 1.429 0 01-.036-.086l-.034.086c-.678.267-1.436.143-2.275-.373C4.544 2.7 4.087 1.941 3.849.842L3.8.582a.5.5 0 01.542-.584c.838.084 1.61.474 2.315 1.169.447.44.74.857.876 1.251.135-.394.427-.81.874-1.251C9.111.472 9.883.082 10.721-.002a.5.5 0 01.137.005z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgRulesVegetarian.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgRulesVegetarian.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgRulesVegetarian svgRef={ref} {...props} />);
export default ForwardRef;
